import { storeManager } from '@pressreader/appstore';
import { contextMenuManager } from '@pressreader/ui-contextmenu';
import { makeLazy } from '@pressreader/utils';

import { MODULE_NAME, TRANSLATE_CONTEXT_MENU_NAME } from '../constants';

import { reducer } from './reducer';
import { saga } from './sagas';

// Lazy: registered menus render inside a Suspense boundary, so registration only
// needs the component type — the menu code loads when the menu first opens.
const TranslateContextMenu = makeLazy(
    () => import(/* webpackChunkName: "app.menus" */ '../components/menus/translate.contextmenu'),
    'TranslateContextMenu',
);

contextMenuManager.register(TRANSLATE_CONTEXT_MENU_NAME, TranslateContextMenu);
storeManager.addFeature(MODULE_NAME, reducer, saga);

export {
    abortScrollRestoreAction,
    addTopBarMenuItemsAction,
    changeFontAction,
    changeFontDone,
    changeFontScaleAction,
    changeInterfaceLanguageAction,
    changeLineSpacingAction,
    checkIssueReadLimitsAction,
    decreaseFontScaleAction,
    fontScaleChanged,
    increaseFontScaleAction,
    legacyAppLoadBegan,
    legacyAppLoadDone,
    legacyAppLoadFailed,
    lineSpacingChanged,
    openChangeInterfaceLanguageMenuAction,
    openFontsMenuAction,
    openFontTypeMenuAction,
    openLegacyOptionsMenuAction,
    openTranslateMenuAction,
    removeTopBarMenuItemsAction,
    translateMenuLanguageCodeChanged,
} from './actions';
export { createNavigationCompletion } from './sagas/navigation.completion';
export { claimScrollRestore, resetScrollUnlessRestoring } from './sagas/scroll.restore';
export * from './selectors';
